import React, { createContext, useContext, useState } from "react";
import useSWR from "swr";
import { fetchData } from "../../lib/dashboard/data";
import { sendData } from "../../lib/dashboard/actions";

const GlobalMarketProductPriceChartContext = createContext();

const GlobalMarketProductPriceChartProvider = ({ children }) => {
  const [selected, setSelected] = useState({
    industry: null,
    commodityType: null,
    commodity: null,
    transitType: null,
  });
  const [chartData, setChartData] = useState({
    data: [],
    isLoading: false,
  });
  const [isFavoritesModal, setIsFavoritesModal] = useState(false);

  // Fetch industries
  const industries = useSWR("/global-market/industry", fetchData, {
    dedupingInterval: 60 * 60 * 1000,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  // Fetch commodity types based on selected industry
  const commodityTypes = useSWR(
    selected.industry
      ? `/global-market/commodity-type/${selected.industry.id}`
      : null,
    fetchData,
    {
      dedupingInterval: 60 * 60 * 1000,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  // Fetch commodities based on selected commodity type
  const commodities = useSWR(
    selected.commodityType
      ? `/global-market/commodity/${selected.commodityType.id}`
      : null,
    fetchData,
    {
      dedupingInterval: 60 * 60 * 1000,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  // Fetch transit types based on selected commodity
  const transitTypes = useSWR(
    selected.commodity
      ? `/global-market/transit/${selected.commodity.id}`
      : null,
    fetchData,
    {
      dedupingInterval: 60 * 60 * 1000,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  // Fetch favorites
  const favorites = useSWR("/favorite/global-favorite-price-chart", fetchData, {
    dedupingInterval: 60 * 60 * 1000,
  });

  const handleShowChart = async (body) => {
    setChartData((prev) => ({ ...prev, isLoading: true }));

    const { status, data } = await sendData(body, "/global-market/price-chart");
    if (status === 200) setChartData((prev) => ({ ...prev, data }));
    setChartData((prev) => ({ ...prev, isLoading: false }));
  };

  return (
    <GlobalMarketProductPriceChartContext.Provider
      value={{
        industries,
        commodityTypes,
        commodities,
        transitTypes,
        selected,
        setSelected,
        chartData: chartData.data,
        setChartData,
        isLoadingChart: chartData.isLoading,
        favorites: favorites.data,
        isFavoritesValidation: favorites.isValidating,
        handleShowChart,
        isFavoritesModal,
        setIsFavoritesModal,
      }}
    >
      {children}
    </GlobalMarketProductPriceChartContext.Provider>
  );
};

export default GlobalMarketProductPriceChartProvider;

export const useGlobalMarketProductPriceChartContext = () =>
  useContext(GlobalMarketProductPriceChartContext);
